// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration (TKMB)
const firebaseConfig = {
  apiKey: "AIzaSyCwvzwY7d-EvDEnINYQiH0jCs9lk6Pmvuw",
  authDomain: "tkmbwebsite.firebaseapp.com",
  databaseURL: "https://tkmbwebsite-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "tkmbwebsite",
  storageBucket: "tkmbwebsite.firebasestorage.app",
  messagingSenderId: "798988873081",
  appId: "1:798988873081:web:cbd8fea7d7d8d9ef6193a8",
  measurementId: "G-2N6BFYXVMK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Realtime Database (site verisi buradan okunuyor)
export const database = getDatabase(app);
export const storage = getStorage(app);

export { analytics };
export default app;
